import gql from 'graphql-tag'

import { ExternalSchoolFieldsFragment } from './externalSchool'
import { ExternalSchoolWithProfileFieldsFragment } from './externalSchoolWithProfile'

export const EXTERNAL_SCHOOL_QUERY = gql`
  query ExternalSchool($id: Int!) {
    externalSchool(id: $id) {
      ...ExternalSchoolFields
      ...ExternalSchoolWithProfileFields
    }
  }

  ${ExternalSchoolFieldsFragment}
  ${ExternalSchoolWithProfileFieldsFragment}
`
